<template>
  <div>
    <v-alert
      text
      outlined
    >
      <v-layout
        v-if="onAdd"
        align-center
      >
        <div style="padding-right: 20px;">{{ $t('menus.info.addMenu') }}</div>
        <v-spacer/>
        <v-btn
          color="enterpriseColor"
          outlined
          @click="onAdd"
        >
          {{ $t('common.addMenu') }}
        </v-btn>
      </v-layout>
      <v-divider
        v-if="onAdd"
        class="my-4"
      />
      <v-layout
        align-center
        wrap
        style="font-size: 14px;line-height:2.5"
      >
        <v-flex xs12>
          <div style="font-weight: normal;margin-bottom:10px;">{{ $t('menus.info.iconAndFunction') }}</div>
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-plus-circle</v-icon> {{ $t('menus.info.addContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-cursor-move</v-icon> {{ $t('menus.info.sortContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-pencil-circle</v-icon> {{ $t('menus.info.editContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-routes</v-icon> {{ $t('menus.info.language') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-undo</v-icon> {{ $t('menus.info.cancel') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-file-document-edit-outline</v-icon> {{ $t('menus.info.menuWithoutContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-delete-circle</v-icon> {{ $t('menus.info.deleteContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-file-document-edit</v-icon> {{ $t('menus.info.menuWithContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-content-save</v-icon> {{ $t('menus.info.saveContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-folder-edit</v-icon> {{ $t('menus.info.submenus') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-lock</v-icon> {{ $t('menus.info.lockContent') }}
        </v-flex>
        <v-flex xs6>
          <v-icon>mdi-format-strikethrough</v-icon> {{ $t('menus.info.finished') }}
        </v-flex>
      </v-layout>
    </v-alert>
    <center style="font-size: 12px;opacity:0.5"><div v-html="info" /></center>
  </div>
</template>

<script>
  export default {
    props: {
      onAdd: {
        type: Function,
        default: null
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      info () {
        return process.env.VUE_APP_INFO
      }
    },
  }
</script>
